import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsContractPlan } from './useGetPartnerAdminsContractPlan';

type IUseContractPlanDetail = (planId: number) => {
  state: {
    /** 契約プラン詳細データ */
    data: GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200;
  };
};

/**
 * 契約プラン詳細のコンポーネントフック
 *
 * - threeLetterCode を Cookie から取得し、API hook に渡す
 */
export const useContractPlanDetail: IUseContractPlanDetail = planId => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsContractPlan({
    threeLetterCode,
    planId,
  });

  return {
    state: {
      data,
    },
  };
};
